// Apollo
import { apolloClient } from '@/vue-apollo'
// Config environments
import { config } from '@/config'
// GraphQL
import getUser from '@/graphql/getUser.gql'
import gql from 'graphql-tag'

const actions = {
  async getUser (context) {
    let phone = localStorage.getItem('CognitoIdentityServiceProvider.' + config.userPoolWebClientId + '.LastAuthUser')

    // let phone = ''

    await apolloClient.query({
      query: gql`${getUser}`,
      variables: {
        phone
      }
    })
      .then(response => {
        const query = response.data
        context.commit('setUser', query.users[0])
        if (!query.users[0]) {
          context.commit('logOut')
        }
      })
  },
  setUser (context, data) {
    context.commit('setUser', data)
  },
  logOut (context) {
    context.commit('logOut')
  }
}

export default actions
